// src/pages/NewProductPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NewProductPage.css';
import { API_URL } from "../config";

function NewProductPage({ currentUser }) {
    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [formData, setFormData] = useState({
        category_id: '',
        name: '',
        description: '',
        manufacturer: '',
        quantity: 0,
        catalog_number: '',
        serial_number: '',
        unit_of_measure: '',
        measure: '',
        purchase_link: '',
        location_id: '',
        price: '',
        notes: ''
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
        fetchLocations();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${API_URL}/categories`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Błąd pobierania kategorii');
            const data = await response.json();
            setCategories(data);
        } catch (error) {
            console.error('Błąd:', error);
        }
    };

    const fetchLocations = async () => {
        try {
            const response = await fetch(`${API_URL}/locations`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Błąd pobierania lokalizacji');
            const data = await response.json();
            setLocations(data);
        } catch (error) {
            console.error('Błąd:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.category_id || !formData.name || !formData.description) {
            setError('Wymagane pola: kategoria, nazwa, opis');
            return;
        }
        try {
            const response = await fetch(`${API_URL}/products`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Błąd dodawania produktu');
            }
            navigate('/magazyn');
        } catch (error) {
            console.error('Błąd:', error);
            setError(error.message);
        }
    };

    return (
        <div className="new-product-page">
            <h2>Dodaj Nowy Produkt</h2>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit} className="new-product-form">
                <div className="form-group">
                    <label>Kategoria:</label>
                    <select name="category_id" value={formData.category_id} onChange={handleChange} required>
                        <option value="">Wybierz kategorię</option>
                        {categories.map(cat => (
                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Nazwa:</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Opis:</label>
                    <textarea name="description" value={formData.description} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Producent:</label>
                    <input type="text" name="manufacturer" value={formData.manufacturer} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Ilość:</label>
                    <input type="number" name="quantity" value={formData.quantity} onChange={handleChange} min="0" />
                </div>
                <div className="form-group">
                    <label>Numer katalogowy:</label>
                    <input type="text" name="catalog_number" value={formData.catalog_number} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Numer seryjny:</label>
                    <input type="text" name="serial_number" value={formData.serial_number} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Jednostka miary:</label>
                    <input type="text" name="unit_of_measure" value={formData.unit_of_measure} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Miara:</label>
                    <input type="number" name="measure" value={formData.measure} onChange={handleChange} step="0.01" />
                </div>
                <div className="form-group">
                    <label>Link zakupu:</label>
                    <input type="text" name="purchase_link" value={formData.purchase_link} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Lokalizacja:</label>
                    <select name="location_id" value={formData.location_id} onChange={handleChange}>
                        <option value="">Wybierz lokalizację</option>
                        {locations.map(loc => (
                            <option key={loc.id} value={loc.id}>{loc.name}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Cena:</label>
                    <input type="number" name="price" value={formData.price} onChange={handleChange} step="0.01" />
                </div>
                <div className="form-group">
                    <label>Uwagi:</label>
                    <textarea name="notes" value={formData.notes} onChange={handleChange} />
                </div>
                <button type="submit" className="btn-submit">Dodaj Produkt</button>
            </form>
        </div>
    );
}

export default NewProductPage;